let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6lmZu")).then(() => parcelRequire('2jXoY'));